import { render, staticRenderFns } from "./releaseRecord.vue?vue&type=template&id=a599bc6e&scoped=true"
import script from "./releaseRecord.vue?vue&type=script&lang=js"
export * from "./releaseRecord.vue?vue&type=script&lang=js"
import style0 from "./releaseRecord.vue?vue&type=style&index=0&id=a599bc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a599bc6e",
  null
  
)

export default component.exports